import { format, Locale } from 'date-fns'
import { SelectedSlot } from '@customTypes/Availabilities'

export const getAppointmentDateAndTimeStrings = (
  selectedDateAndTime: SelectedSlot,
  lang: string | undefined,
  locale: Locale,
  addYear = true
): string[] => {
  const { day, time } = selectedDateAndTime
  if (!day || !time) {
    return []
  }
  const date = new Date(`${day}T${time}`)

  return [
    format(date, `EEE${lang === 'en' ? '.' : ''} d MMMM${addYear ? ' yyyy' : ''}`, { locale }),
    format(date, 'kk:mm'),
  ]
}
